<template>
  <d-modal
    size="lg"
    :class="{ 'big-popup': true, 'is-hidden': isHidden }"
    @close="handleClose">
    <d-modal-header class="px-4">
      <d-modal-title>
        Kartony z HPL
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="px-4">
      <d-alert
        v-if="loadError"
        show
        theme="warning"
        class="mb-4">
        Wczytywanie danych nie powiodło się.
        <a href="javascript:window.location.reload();" class="alert-link">
          Odśwież stronę
        </a>
        aby spróbować ponownie.
      </d-alert>
      <template v-else>
        <div
          v-if="!loaded"
          class="text-center py-5 text-primary">
          <div
            class="spinner-border spinner-border-sm mr-2 mt-1"
            role="status">
          </div>
          Trwa ładowanie danych&hellip;
        </div>

        <div v-else>
          <d-card style="width: 100%;">
            <order-boxes-list
              ref="order-boxes-list"
              :boxes-list="boxesList"
              :is-on-dashboard="true" />
          </d-card>

          <pagination :meta-data="paginationMetaData" class="mt-3" />
        </div>
      </template>
    </d-modal-body>
  </d-modal>
</template>

<script>
import ListUtils from '@/utils/ListUtils.js';
import OrderBoxesList from '@/components/forms/order/OrderBoxesList.vue';
import HasPagination from '@/mixins/HasPagination.vue';
import Pagination from '@/components/common/Pagination.vue';

export default {
  name: 'orders-boxes-popup',
  mixins: [
    HasPagination
  ],
  components: {
    'order-boxes-list': OrderBoxesList,
    'pagination': Pagination
  },
  data () {
    return {
      isHidden: true,
      loaded: false,
      loadError: false,
      boxesList: []
    };
  },
  mounted () {
    this.$bus.$on('orders-boxes-popup-show', this.openPopup);
    this.$bus.$on('pagination-page-changed', this.loadItemsData);
  },
  methods: {
    handleClose () {
      this.loaded = false;
      this.loadError = false;
      this.isHidden = true;
    },
    openPopup () {
      this.currentPage = 1;
      this.loadItemsData();

      setTimeout(() => {
        this.isHidden = false;
      }, 0);
    },
    loadItemsData () {
      this.loaded = false;
      this.loadError = false;

      const baseEndpoint = '/api/dashboard/stats/order-boxes';

      ListUtils.loadItemsData(this, {
        method: 'get',
        endpoint: `${baseEndpoint}?page=${this.currentPage}`,
        listField: 'boxesList',
        pagination: true
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('orders-boxes-popup-show', this.openPopup);
    this.$bus.$off('pagination-page-changed', this.loadItemsData);
  }
}
</script>

<style lang="scss" scoped>
.modal.is-hidden {
  display: none;
  pointer-events: none;
}
.modal-body {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
}
</style>
